import React from 'react';
import { useState } from 'react';
import { CcfLogger } from '@nice-ccf/agent-sdk';
import { CcfSwitchItem, useTranslator } from '@nice-ccf/ui-controls';
import { LocalStorageHelper, NotificationSettings } from '@nice-ccf/core-sdk';

import AccessTimeIcon from '@mui/icons-material/AccessTime';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';

/**
 * @example CcfDisplayAndAccessability()
 * @returns
 */
export function CcfDisplayAndAccessability() {
  const [twentyFourHourTime, setTwentyFourHourTime] = useState(false);
  const [panelPopout, setPanelPopout] = useState(false);
  const [translate] = useTranslator();

  /**
   *
   * @param event - switch click event
   * @param checked - switch boolean
   * @example handleChange
   */
  const handleChange = (
    event: React.SyntheticEvent<Element, Event>,
    checked: boolean
  ) => {
    const target = event.target as HTMLInputElement;

    LocalStorageHelper.setItem(target.name, checked);

    switch (target.name) {
      case NotificationSettings.TWENTY_FOUR_HOUR_TIME:
        setTwentyFourHourTime(checked);
        break;
      case NotificationSettings.PANEL_POPOUT:
        setPanelPopout(checked);
        break;
      default:
        break;
    }
  };

  return (
    <div style={{ height: '100%' }}>
      <List
        sx={{ width: '100%', bgcolor: 'background.paper' }}
        subheader={<ListSubheader>{translate('display')}</ListSubheader>}
      >
        <CcfSwitchItem
          handleChange={handleChange}
          icon={<AccessTimeIcon />}
          id={'twentyFourHourTime'}
          isChecked={twentyFourHourTime}
          name={translate(NotificationSettings.TWENTY_FOUR_HOUR_TIME)}
          text="twentyFourHourTime"
        />
        <CcfSwitchItem
          handleChange={handleChange}
          // hideLessThanExtraLarge={true}
          icon={<OpenInBrowserIcon />}
          isChecked={panelPopout}
          name={translate(NotificationSettings.PANEL_POPOUT)}
          text="panelOpenInBrowser"
        />
      </List>
    </div>
  );
}

export default CcfDisplayAndAccessability;
